import React from "react";
import { useHistory } from "react-router-dom";
import LogoImage from "../../utils/logo.png";

const Logo = () => {
  const history = useHistory();


  const onClick = () => {
    history.push({
      pathname: "/",
    });
  };
  
  return (
    // <div className="logo d-flex justify-content-center">
    //   <img src={LogoImage} style={{ width: "100%" }} class="img-fluid"></img>
    // </div>
    <div className="d-flex justify-content-start align-items-start">
  <img src={LogoImage} style={{ width: "200px", position: "absolute", top: "20px", left: "20px" }} class="img-fluid" alt="Logo" />
  </div>
  
  );
};

export default Logo;
